export const passwordPattern = /^(?=.*[A-Z])(?!.* )(?=.*[a-z])(?=.*[0-9]{2,})/;
export const phonePattern =
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
export const datePattern = /^\d{4}-\d{2}-\d{2}$/;
export const pattern = /a/;
export const positiveNumber = /^[+]?([.]\d+|\d+([.]\d+)?)$/;
